import { PerformanceLog } from './performance-log.decorator';

/**
 * RenderingPerformanceLog is a method decorator factory
 * It returns a method decorator
 *
 * The returned decorator will wrap the original method
 * and log initial timestamp, final timestamp and execution duration of the method
 *
 * It also counts for any rendering update that might happen as result of the method execution
 */
export function RenderingPerformanceLog(countExecution = false, name?: string, data?: () => any): MethodDecorator {
  return PerformanceLog('RenderingPerformanceLog', true, countExecution, name, data);
}
